export const reviewFilterConfig = {
  page: {
    default: () => 1,
    source: "query",
    state: {
      encode: (value) => {
        if (1 !== value) {
          return value;
        }
      },
      decode: (value) => {
        return parseInt(value);
      },
    },
    request: {
      encode: (value) => {
        return parseInt(value);
      },
    },
  },
  pageSize: {
    default: () => 25,
    source: "query",
    state: {
      encode: (value) => {
        if (25 !== value) {
          return value;
        }
      },
      decode: (value) => {
        return parseInt(value);
      },
    },
    request: {
      encode: (value) => {
        return parseInt(value);
      },
    },
  },
};
